import { Close, Restore } from '@mui/icons-material';
import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { FileDirectoryDeleteDTO, RestoreDeletedProjectDocumentFilesRequest, VovClient } from '../../../../ApiOld/ApiServerVov';
import { useTranslation } from 'react-i18next';
import './EmployeeDocumentTreeScene.css'
import { useApi } from '../../../../ApiOld/Api/useApi';
import { ColumnChooser, ColumnDirective, ColumnsDirective, ExcelExport, Filter, FilterSettingsModel, GridComponent, Group, Inject, Page, Reorder, Resize, Search, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { useEmployeesPermissionContext } from '../../../../Contexts/Permissions/EmployeesPermissionContext';
import { RestoreDeletedEmployeeDocumentFilesRequest } from '../../../../ApiOld/Api/ApiServerVov';

interface EmployeeDocumentFileThrashSceneProps {
    documentId: number;
    open: boolean;
    onClose: (refresh: boolean) => void;
}

export default function EmployeeDocumentFileThrashScene(props: EmployeeDocumentFileThrashSceneProps) {
    const { documentId, open, onClose } = props;
    const [files, setFiles] = React.useState<FileDirectoryDeleteDTO[] | null>(null);
    const [restoring, setRestoring] = React.useState<boolean>(false);
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    const { permissions, reloadPermissions } = useEmployeesPermissionContext();

    const { authorizedApi } = useApi(VovClient);
    const grid = React.useRef<GridComponent>(null);

    useEffect(() => {
        if (!permissions)
            reloadPermissions();
    }, [reloadPermissions]);

    useEffect(() => {
        if (open)
            authorizedApi?.getDeletedEmployeeDocumentFilesToRestore(documentId).then(p => {
                setFiles(p.files ?? []);
            });
    }, [open]);

    let filterOptions: FilterSettingsModel = {
        type: 'Excel',
        ignoreAccent: true
    };


    return <Dialog maxWidth="lg"
        open={open} onClose={() => onClose(false)}
        sx={{ margin: 'auto' }}>
        <DialogTitle sx={{ zIndex: "28", backgroundColor: '#F5F5F5' }}>
            <div style={{ backgroundColor: '#F5F5F5', zIndex: "200" }}>
                <div style={{ float: 'left', display: 'flex' }}>
                    <Typography variant='h1' fontWeight='bold' fontSize={20}>{t('files.restoreFiles')} </Typography>
                </div>
                <div style={{ float: 'right', display: 'flex', alignContent: 'flex-end' }}>
                    <div style={{ marginTop: '-14px', display: 'flex' }}>
                        <Button disabled={restoring} variant='contained' startIcon={<Restore />} onClick={() => {
                            if (grid.current) {
                                const selectedFiles = grid.current.getSelectedRecords();
                                let result = selectedFiles.map(a => {
                                    type ObjectKey = keyof typeof a;
                                    const myVar = 'id' as ObjectKey;
                                    return a[myVar];
                                });

                                let ids = ((result as any) as number[]);
                                if (selectedFiles.length > 0) {
                                    setRestoring(true);
                                    authorizedApi.restoreDeletedEmployeeDocumentFiles(new RestoreDeletedEmployeeDocumentFilesRequest({ documentId: documentId, filesIds: ids })).then(p => {
                                        setRestoring(false);
                                        onClose(true);
                                    });
                                }
                            }
                        }} sx={{ marginTop: '8px' }}>
                            {t('refresh')}
                        </Button>
                        <IconButton onClick={() => onClose(false)} >
                            <Close />
                        </IconButton>
                    </div>
                </div>
            </div>
        </DialogTitle>
        <DialogContent>
            <div>
                {files && <GridComponent id="grid-component-trash-files" allowSorting={true}
                    allowReordering={true} allowResizing={true} showColumnChooser={true}
                    allowExcelExport={true} allowMultiSorting={true} allowGrouping={false}
                    locale={i18n.language} enablePersistence={false}
                    ref={grid}
                    allowPaging={true}
                    style={{ backgroundColor: '#F5F5F5' }}
                    pageSettings={{ pageSize: 20, pageSizes: [10, 20, 30, 50, 100] }}
                    //  columnDataStateChange={(e) => { console.log(e) }}
                    selectionSettings={{ checkboxMode: 'ResetOnRowClick' }}
                    searchSettings={{ ignoreCase: true, ignoreAccent: true }}
                    filterSettings={filterOptions}
                    allowFiltering={true}
                    dataSource={files}>
                    <ColumnsDirective>
                        <ColumnDirective type='checkbox' width='30' />
                        <ColumnDirective field='name' headerText={t('file')} width='100' />


                    </ColumnsDirective>
                    <Inject services={[Sort, Group, Filter, Search, Toolbar, ExcelExport, Reorder, Resize, ColumnChooser, Page]} />
                </GridComponent>}
            </div>
        </DialogContent>
    </Dialog>;
}
